declare global {
  interface Window {
    SAIL_TOOLKIT_PRESENT?: boolean;
  }
}

// The Sail Toolkit chrome extension sets window.SAIL_TOOLKIT_PRESENT synchronously at
// document_start, before any React module evaluation, so this check is
// reliable.
export const SAIL_TOOLKIT_ACTIVE =
  typeof globalThis !== 'undefined' &&
  (globalThis as unknown as Window).SAIL_TOOLKIT_PRESENT === true;

export const SAIL_TOOLKIT_COMMUNICATION_ID = 'sail-toolkit-v1';
